import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DirectorCreateModalUI from './DirectorCreateModalUI.js'

class DirectorCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      accountId: this.props.account && this.props.account.accountId,
      // form events
      submitted: false,
      // form field
      directorName: '',
      directorNameError: null,
      directorNumber: '',
      directorNumberError: null,
      phoneNumber: '',
      phoneNumberError: null,
      address: '',
      addressError: null,
      email: '',
      emailError: null,
    }
  }

  render() {
    return (
      <DirectorCreateModalUI
        context={this.props.context}
        account={this.props.account}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelCreate}
        // form fields
        directorName={this.state.directorName}
        onDirectorNameChange={(event) => this.setState({ directorName: event.target.value })}
        directorNameError={this.state.directorNameError}
        setDirectorNameError={(error) => { this.setState({ directorNameError: error }) }}
        directorNumber={this.state.directorNumber}
        onDirectorNumberChange={(event) => this.setState({ directorNumber: event.target.value })}
        directorNumberError={this.state.directorNumberError}
        setDirectorNumberError={(error) => { this.setState({ directorNumberError: error }) }}
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(event) => this.setState({ phoneNumber: event.target.value })}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => { this.setState({ phoneNumberError: error }) }}
        address={this.state.address}
        onAddressChange={(event) => this.setState({ address: event.target.value })}
        addressError={this.state.addressError}
        setAddressError={(error) => { this.setState({ addressError: error }) }}
        email={this.state.email}
        onEmailChange={(event) => this.setState({ email: event.target.value })}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setState({ emailError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.account)
      return
    if (!prevProps.account || prevProps.account.accountId !== this.props.account.accountId)
      this.setState({accountId: this.props.account.accountId})
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.state.accountId}/directors`,
      this.onSubmitCallback, {
        directorName: this.state.directorName,
        directorNumber: this.state.directorNumber,
        phoneNumber: this.state.phoneNumber,
        address: this.state.address,
        // email: this.state.email,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreate()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(DirectorCreateModalSF)
